"use strict";
/// <reference path="../app.typings.d.ts" />
var Guid = /** @class */ (function () {
    function Guid() {
    }
    Guid.empty = '00000000-0000-0000-0000-000000000000';
    Guid.alpha = 'ef68fd19-86c9-478d-a0b3-2d62de2d41a1';
    return Guid;
}());
